import { tw } from '@/utils/tw';
import { default as BaseTagTheme } from 'base/components/Tag/theme';

const Tag = tw.theme({
  extend: BaseTagTheme,
  base: 'uppercase',
  variants: {
    colors: {
      default: 'bg-gray-100 text-gray-800 ring-secondary-200 hover:text-gray-800',
      text: '',
    },
    size: {
      small: '',
      medium: '',
      large: '',
      text: '',
    },
    variant: {
      default: '',
      text: '',
    },
  },
});

export default Tag;
